import { getCustomTrackMergeFn } from '@bc/shared/tracking';

export const trackMergeFn = getCustomTrackMergeFn(['id_product', 'id_brand']);
